var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4996 62.1065L90.9464 84.5534L85.0539 90.446L62.607 67.9991C56.9625 72.3868 49.8698 74.9997 42.1668 74.9997C23.7573 74.9997 8.8335 60.0758 8.8335 41.6663C8.8335 23.2568 23.7573 8.33301 42.1668 8.33301C60.5763 8.33301 75.5002 23.2568 75.5002 41.6663C75.5002 49.3693 72.8873 56.462 68.4996 62.1065ZM42.1668 66.6663C55.9739 66.6663 67.1668 55.4735 67.1668 41.6663C67.1668 27.8592 55.9739 16.6663 42.1668 16.6663C28.3597 16.6663 17.1668 27.8592 17.1668 41.6663C17.1668 55.4735 28.3597 66.6663 42.1668 66.6663Z",
    fill: "#D9DAF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f9092045220861ebdc948f2284b4ea69.svg";
export { ForwardRef as ReactComponent };